export default "__VITE_ASSET__NFxgtkH$__"